<template>
  <GrTooltip :width="tooltipWidth" :hideBox="infoText === null">
    <slot name="icon">
      <div
        class="tooltip-icon fw-bolder text-tiny"
        :class="disabled ? '' : 'cursor-pointer'"
        v-if="formTooltip"
      >
        i
      </div>
      <img
        v-else
        :src="tooltipIcon"
        :alt="altText"
        :class="[`${size}-icon`, disabled ? '' : 'cursor-pointer']"
      />
    </slot>

    <template #content>
      <p class="text-small" v-html="infoText"></p>
    </template>
  </GrTooltip>
</template>

<script setup lang="ts">
import GrTooltip from "./GrTooltip.vue";
import { withDefaults, defineProps } from "vue";
import infoIcon from "../../assets/img/info-icon.svg";

type InformationTooltipProps = {
  infoText: string | null;
  tooltipIcon?: string;
  altText?: string;
  size?: null | string;
  formTooltip?: boolean;
  disabled?: boolean;
  tooltipWidth?: "large" | "medium" | "small";
};

withDefaults(defineProps<InformationTooltipProps>(), {
  infoText: "",
  tooltipIcon: infoIcon,
  altText: "Info icon",
  size: null,
  formTooltip: false,
  disabled: false,
  tooltipWidth: "large"
});
</script>

<style scoped>
.small-icon {
  width: 18px;
}

.large-icon {
  width: 24px;
}

.tooltip-icon {
  display: flex;
  align-items: center;
  background-color: white;
  border: 1.5px solid black;
  justify-content: center;
  border-radius: 100%;
  height: 25px;
  width: 25px;
}
</style>
